import * as actionTypes from './actionTypes';
import apiCall from '../app/apiCall';
import { filterPayload as initialFilterPayload } from './reducer';

export const fetchOpenTimeActivitiesRequest = (filterPayload, persistFilter) =>
  ({ type: actionTypes.FETCH_OPEN_TIME_ACTIVITIES_REQUEST, filterPayload, persistFilter });
export const fetchOpenTimeActivitiesFailure = message =>
  ({ type: actionTypes.FETCH_OPEN_TIME_ACTIVITIES_FAILURE, message });
export const fetchOpenTimeActivitiesSuccess = (activities, layover) =>
  ({ type: actionTypes.FETCH_OPEN_TIME_ACTIVITIES_SUCCESS, activities, layover });
export const fetchBidAnalyzerRequest = () =>
  ({ type: actionTypes.FETCH_BID_ANALYZER_REQUEST });
export const fetchBidAnalyzerFailure = error =>
  ({ type: actionTypes.FETCH_BID_ANALYZER_FAILURE, error });
export const fetchBidAnalyzerSuccess = analysis =>
  ({ type: actionTypes.FETCH_BID_ANALYZER_SUCCESS, analysis });
export const addOpenTimeRequestSuccess = () =>
  ({ type: actionTypes.ADD_OPEN_TIME_REQUEST_SUCCESS });
export const addOpenTimeRequestFailure = () =>
  ({ type: actionTypes.ADD_OPEN_TIME_REQUEST_FAILURE });

export function dispatchAddOpenTimeRequestSuccess() {
  return (dispatch) => {
    dispatch(addOpenTimeRequestSuccess());
  };
}

export function dispatchAddOpenTimeRequestFailure() {
  return (dispatch) => {
    dispatch(addOpenTimeRequestFailure());
  };
}

export function fetchBidAnalyzer(bidSessionId, staffId) {
  return (dispatch) => {
    dispatch(fetchBidAnalyzerRequest());

    function getBidAnalisis() {
      // Params to request bids and preferences.
      const bidAnalysisUrl = `preferences/rankings/bid-session/${bidSessionId}/employee/${staffId}?refresh_now=true`;
      apiCall(bidAnalysisUrl)
        .then(response => dispatch(fetchBidAnalyzerSuccess(response.data)))
        .catch(error => dispatch(fetchBidAnalyzerFailure(error.response)));
    }
    getBidAnalisis();
  };
}

export function fetchOpenTimeActivities(sessionData, filterPayload, persistFilter = false, showLayOverDetail = true) {
  return (dispatch) => {
    if (!filterPayload) {
      filterPayload = { ...initialFilterPayload };
      persistFilter = true;
    }

    dispatch(fetchOpenTimeActivitiesRequest(filterPayload, persistFilter));

    // Payload to request activities from search endpoint
    const searchPayload = { ...sessionData, ...filterPayload, showLayOverDetail };
    const activitiesRequestUrl = 'activities/search';

    if (searchPayload.activityAttributes.length === 0) {
      searchPayload.activityAttributes = null;
    }

    apiCall(activitiesRequestUrl, 'post', searchPayload)
      .then((response) => {
        const { stationCodes, layoverStationMap, deadHeadValueMap, ...remainingData } = response.data;
        dispatch(fetchOpenTimeActivitiesSuccess(
          {
            activities: remainingData,
          },
          {
            stationCodes,
            layoverStationMap,
            deadHeadValueMap
          }
        ));
      })
      .catch(error => dispatch(fetchOpenTimeActivitiesFailure(error)));
  };
}

export function clearOpenTimeActivities(sessionData, preservedPartialFilter) {
  return (dispatch) => {
    const filterPayload = { ...initialFilterPayload, ...preservedPartialFilter };
    dispatch(fetchOpenTimeActivities(sessionData, filterPayload, true));
  };
}

export function resetFilter(sessionData) {
  return (dispatch) => {
    const filterPayload = { ...initialFilterPayload };
    dispatch(fetchOpenTimeActivities(sessionData, filterPayload, true));
  };
}

export function fetchBidAnalyzerWithOpenTimeActivities(sessionData, filterPayload) {
  return (dispatch) => {
    dispatch(fetchBidAnalyzerRequest());

    (function getBidAnalisis() {
      const { bidSessionId, staffId } = sessionData;
      const bidAnalysisUrl = `preferences/rankings/bid-session/${bidSessionId}/employee/${staffId}?refresh_now=true`;
      apiCall(bidAnalysisUrl)
        .then((response) => {
          dispatch(fetchBidAnalyzerSuccess(response.data));

          /*
          Fetch again Open Time Search activities only on a SUCCESSFUL
          response from Bid Analyzer
          */
          if (response.data.result === 'SUCCESSFUL' || response.data.result === 'NO_CHANGES') {
            dispatch(
              fetchOpenTimeActivities(sessionData, filterPayload)
            );
          }
        })
        .catch(error => dispatch(fetchBidAnalyzerFailure(error.response)));
    }());
  };
}
